import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Box, Card, Flex, Hide } from 'roo-ui/components';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';
import theme from 'lib/theme';
import { PropTypes } from 'prop-types';

const PlainSkeletonCard = styled(Box)`
  opacity: 0.6;
  overflow: hidden;
`;

PlainSkeletonCard.displayName = 'PlainSkeletonCard';

const ShadowedSkeletonCard = styled(Card)`
  opacity: 0.6;
  overflow: hidden;
  box-shadow: ${themeGet('shadows.result')};
  border-radius: ${themeGet('radii.default')};
`;

ShadowedSkeletonCard.displayName = 'ShadowedSkeletonCard';

const RoomSkeletonCard = () => (
  <PlainSkeletonCard mb={5}>
    <Flex flexDirection={['column', 'row']} px={[2, 0]}>
      <Box>
        <PulsingLoadingBlock
          mr={[0, 1]}
          height={theme.imageSizes.legacyRoomTypeThumbnail.height}
          width={theme.imageSizes.legacyRoomTypeThumbnail.width}
          borderRadius="default"
        />
      </Box>
      <Box p={[0, 4]}>
        <PulsingLoadingBlock height={20} width={260} />
        <PulsingLoadingBlock height={14} width={160} />
      </Box>
    </Flex>
  </PlainSkeletonCard>
);

const OfferSkeletonCard = () => (
  <ShadowedSkeletonCard mb={5}>
    <Flex flexDirection={['column', 'row']} alignItems="center">
      <Box width="30%">
        <PulsingLoadingBlock height={14} width="20%" />
        <PulsingLoadingBlock height={14} width="80%" />
        <PulsingLoadingBlock height={14} width="30%" mt={5} />
        <PulsingLoadingBlock height={14} width="30%" />
      </Box>

      <Box width="50%">
        <Hide xs>
          <Flex>
            <Box width="35px">
              <PulsingLoadingBlock height={25} width={25} borderRadius="25px" />
            </Box>
            <Box>
              <PulsingLoadingBlock height={14} width={150} />
              <PulsingLoadingBlock height={14} width={200} />
            </Box>
          </Flex>
        </Hide>
      </Box>
      <Box width="20%">
        <Hide xs>
          <Flex flexDirection="column" alignItems="flex-end">
            <PulsingLoadingBlock height={14} width={150} />
            <PulsingLoadingBlock height={20} width={60} />
            <PulsingLoadingBlock height={40} width={90} />
          </Flex>
        </Hide>
      </Box>
    </Flex>
  </ShadowedSkeletonCard>
);

const LoaderSkeletonCard = React.memo(({ index }) => {
  return (
    <Box key={index} mb={10}>
      <RoomSkeletonCard />
      <OfferSkeletonCard />
      <OfferSkeletonCard />
      <OfferSkeletonCard />
    </Box>
  );
});

LoaderSkeletonCard.displayName = 'LoaderSkeletonCard';

LoaderSkeletonCard.propTypes = {
  index: PropTypes.number,
};

LoaderSkeletonCard.defaultProps = {
  index: 0,
};

export default LoaderSkeletonCard;
